// extracted by mini-css-extract-plugin
export var layout_update = "layout_update-UyR";
export var media_object = "media_object-xmX";
export var media_object_content = "media_object_content-s8t";
export var media_object_image = "media_object_image-j0a";
export var theme_dark = "theme_dark-LAI";
export var theme_light = "theme_light-ID8";
export var trigger_opacity_change = "trigger_opacity_change-4wx";